import React, { useContext } from "react";
import BryntumContext from "../../../../context/bryntumContext.jsx";

const AppBoardButton = () => {
  const { selectedBoard, user } = useContext(BryntumContext);

  const canShowButton = Boolean(user) && Boolean(selectedBoard);

  if (canShowButton) {
    return (
      <span className="font-semibold text-xs">{selectedBoard.name}</span>
    );
  }

  return null;
};

export default AppBoardButton;
